import type { Session } from 'api';
import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, Typography } from 'ui';
import { ExpandMore } from 'ui/icons';

import { EvidenceAiLooseSessionDetails } from '../EvidenceAiLooseSessionDetails/EvidenceAiLooseSessionDetails';
import { EvidenceSessionSummary } from '../EvidenceSessionSummary/EvidenceSessionSummary';

export const EvidenceAiLooseSession = ({
  session,
  defaultExpanded = false,
  siteMaterialId,
}: {
  defaultExpanded?: boolean;
  session: Session;
  siteMaterialId: number;
}) => {
  const { t } = useTranslation('features');
  const { date, uploaded_by, parent_id, origin, parent_content_type_id } = session;

  return (
    <Accordion defaultExpanded={defaultExpanded} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <EvidenceSessionSummary
          date={date}
          uploadedBy={uploaded_by}
          origin={origin}
          showAIChip={true}
          showSelfServeChip={session.is_self_serve}
        />
      </AccordionSummary>
      <AccordionDetails>
        {parent_id && parent_content_type_id ? (
          <EvidenceAiLooseSessionDetails
            parentId={parent_id}
            date={date}
            parentContentTypeId={parent_content_type_id}
            uploadedById={uploaded_by?.id || null}
            siteMaterialId={siteMaterialId}
          />
        ) : (
          <Typography>{t('backlog.common.noData')}</Typography>
        )}
      </AccordionDetails>
      {!session.is_self_serve ? (
        <AccordionActions>
          <Button component={Link} to={`/quality/${siteMaterialId}/sample/${parent_id}/edit`}>
            {t('backlog.evidence.common.editSample')}
          </Button>
        </AccordionActions>
      ) : null}
    </Accordion>
  );
};
